export default __webpack_public_path__ + "static/media/perfumes.40405332.jpeg";